export const INSIGHTS_QUERY_KEY = 'insights';
export const GENERATE_EMAIL_QUERY_KEY = 'generateEmail';
export const EMAILS_QUOTA_QUERY_KEY = 'emailsQuota';

const makeInsightsQueryKey = (companyDomain: string) => [INSIGHTS_QUERY_KEY, companyDomain] as const;
const makeGenerateEmailQueryKey = ({ id, languageCode, index }: { id: string; languageCode: string; index: number }) =>
  [GENERATE_EMAIL_QUERY_KEY, id, index.toString(), languageCode] as const;

export const insightsQueryKey = {
  insights: makeInsightsQueryKey,
  emailsQuota: () => [EMAILS_QUOTA_QUERY_KEY],
  generateEmail: makeGenerateEmailQueryKey,
};
